
document.querySelectorAll('.tab-item').forEach(item => {
  item.addEventListener('click', function() {
    document.querySelectorAll('.tab-item').forEach(tab => tab.classList.remove('active'));
    document.querySelectorAll('.tab-content').forEach(content => content.classList.remove('active'));

    this.classList.add('active');
    document.getElementById(this.getAttribute('data-tab')).classList.add('active');
  });
});

const urlParams = new URLSearchParams(window.location.search);
const colorFromURL = urlParams.get('color'); // Assuming the URL is something like ?color=red

document.querySelectorAll('.color-swatches label').forEach(function(label) {
    if (label.getAttribute('for') === colorFromURL) {
        label.click(); // Trigger click to ensure everything updates
    }
});

 // Color radio buttons 
  document.querySelectorAll('.color-swatches input[name="color"]').forEach(function(sizeInput) {
    sizeInput.addEventListener('change', function() {
      if (this.checked) {
        console.log('Selected Color:', this.value);
      }
    });
  });

 // Size radio buttons for Top
  document.querySelectorAll('input[name="top-size"]').forEach(function(sizeInput) {
    sizeInput.addEventListener('change', function() {
      if (this.checked) {
        console.log('Selected Top Size:', this.value);
      }
    });
  });

  // Material radio buttons for Top
  document.querySelectorAll('input[name="top-material"]').forEach(function(materialInput) {
    materialInput.addEventListener('change', function() {
      if (this.checked) {
        console.log('Selected Top Material:', this.value);
      }
    });
  });

  // Size radio buttons for Bottom
  document.querySelectorAll('input[name="bottom-size"]').forEach(function(sizeInput) {
    sizeInput.addEventListener('change', function() {
      if (this.checked) {
        console.log('Selected Bottom Size:', this.value);
      }
    });
  });

  // Material radio buttons for Bottom
  document.querySelectorAll('input[name="bottom-material"]').forEach(function(materialInput) {
    materialInput.addEventListener('change', function() {
      if (this.checked) {
        console.log('Selected Bottom Material:', this.value);
      }
    });
  });

// Function to get selected values and return variant IDs
function getSelectedValues() {
  var selectedColor = document.querySelector('input[name="color"]:checked')?.value;
  var selectedTopSize = document.querySelector('input[name="top-size"]:checked')?.value;
  var selectedTopMaterial = document.querySelector('input[name="top-material"]:checked')?.value;
  var selectedBottomSize = document.querySelector('input[name="bottom-size"]:checked')?.value;
  var selectedBottomMaterial = document.querySelector('input[name="bottom-material"]:checked')?.value;

  if (!selectedColor || !selectedTopSize || !selectedTopMaterial || !selectedBottomSize || !selectedBottomMaterial) {
    console.log('Not all selections are made.');
    return { topVariantId: null, bottomVariantId: null };
  }

  // Capitalize words
  function capitalizeWords(str) {
    return str.replace(/\b\w/g, char => char.toUpperCase());
  }

  selectedColor = capitalizeWords(selectedColor);

  var topPossibleTitles = [
    `${selectedColor} / ${selectedTopSize} / ${selectedTopMaterial}`,
    `${selectedTopSize} / ${selectedColor} / ${selectedTopMaterial}`,
    `${selectedTopMaterial} / ${selectedColor} / ${selectedTopSize}`,
    `${selectedColor} / ${selectedTopMaterial} / ${selectedTopSize}`,
    `${selectedTopSize} / ${selectedTopMaterial} / ${selectedColor}`,
    `${selectedTopMaterial} / ${selectedTopSize} / ${selectedColor}`
  ];

  var bottomPossibleTitles = [
    `${selectedColor} / ${selectedBottomSize} / ${selectedBottomMaterial}`,
    `${selectedBottomSize} / ${selectedColor} / ${selectedBottomMaterial}`,
    `${selectedBottomMaterial} / ${selectedColor} / ${selectedBottomSize}`,
    `${selectedColor} / ${selectedBottomMaterial} / ${selectedBottomSize}`,
    `${selectedBottomSize} / ${selectedBottomMaterial} / ${selectedColor}`,
    `${selectedBottomMaterial} / ${selectedBottomSize} / ${selectedColor}`
  ];

  var topDropdown = document.getElementById('top-variant-dropdown');
  var bottomDropdown = document.getElementById('bottom-variant-dropdown');

  var topVariantId = null;
  var bottomVariantId = null;

  for (var i = 0; i < topDropdown.options.length; i++) {
    var topOption = topDropdown.options[i];
    if (topPossibleTitles.includes(topOption.text)) {
      topVariantId = topOption.value;
      topQuantity = topOption.getAttribute('data-quantity');
      break;
    }
  }

  for (var j = 0; j < bottomDropdown.options.length; j++) {
    var bottomOption = bottomDropdown.options[j];
    if (bottomPossibleTitles.includes(bottomOption.text)) {
      bottomVariantId = bottomOption.value;
      bottomQuantity = bottomOption.getAttribute('data-quantity');
      break;
    }
  }

  console.log('Selected Top Variant ID:', topVariantId, 'Quantity:', topQuantity);
  console.log('Selected Bottom Variant ID:', bottomVariantId, 'Quantity:', bottomQuantity);

  return { topVariantId, topQuantity, bottomVariantId, bottomQuantity };
}

// Function to add both variants to the cart
function addToCart(topVariantId, bottomVariantId) {
  Promise.all([topVariantId, bottomVariantId])
    .then(results => {
      var topAvailable = results[0];
      var bottomAvailable = results[1];

      if (topAvailable && bottomAvailable) {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('items[0][id]', topVariantId);
        formData.append('items[0][quantity]', 1);
        formData.append('items[1][id]', bottomVariantId);
        formData.append('items[1][quantity]', 1);
        
        if (cart) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        console.log('config', config);
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log('Products added to cart:', response, cart);
            if (cart && response) {
              try {
                cart.renderContents(response);
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                  cartDrawer.classList.remove('is-empty');
                }
              } catch (error) {
                  console.error('Error rendering cart contents:', error);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
      } else {
        console.log('One or both variants are sold out.');
        // Optionally show a message to the user about sold-out items
      }
    });
}

/* ── Sold-out state ──────────────────────────────────────────────────────
   The simple product page strikes through the sizes you cannot buy, badges
   the price and turns the button into "Sold out". A set page has two size
   rows and two products behind them, so the same three things have to be
   worked out here from both sides at once.

   Which sizes are sold out depends on the colour and material in effect, so
   this runs again on every change, not just on load. */

function readSetData(id) {
  var el = document.getElementById(id);
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    console.warn('set-product: could not read ' + id, e);
    return null;
  }
}

var setData = {
  top: readSetData('set-top-data'),
  bottom: readSetData('set-bottom-data')
};

/* Option order differs per product, so find each one by name rather than
   assuming colour/size/material positions. */
function setOptionIndex(names, needle) {
  if (!names) return -1;
  for (var i = 0; i < names.length; i++) {
    if (String(names[i]).toLowerCase().indexOf(needle) !== -1) return i;
  }
  return -1;
}

function sameOption(a, b) {
  return String(a == null ? '' : a).trim().toLowerCase() === String(b == null ? '' : b).trim().toLowerCase();
}

function setCheckedValue(name) {
  var el = document.querySelector('input[name="' + name + '"]:checked');
  return el ? el.value : null;
}

/* true when some variant of that side matches colour + material + size and
   is orderable. Unknown data means "do not block the sale". */
function setSizeAvailable(side, size) {
  var data = setData[side];
  if (!data || !data.variants) return true;

  var ci = setOptionIndex(data.names, 'color');
  var si = setOptionIndex(data.names, 'size');
  var mi = setOptionIndex(data.names, 'material');

  var color = setCheckedValue('color');
  var material = setCheckedValue(side + '-material');

  for (var i = 0; i < data.variants.length; i++) {
    var v = data.variants[i];
    if (si !== -1 && !sameOption(v.o[si], size)) continue;
    if (ci !== -1 && color != null && !sameOption(v.o[ci], color)) continue;
    if (mi !== -1 && material != null && !sameOption(v.o[mi], material)) continue;
    if (v.a) return true;
  }
  return false;
}

/* Mark every size, then settle the button and the price badge on the two
   that are actually selected. */
function updateButtonState() {
  var soldOut = false;

  ['top', 'bottom'].forEach(function (side) {
    document.querySelectorAll('input[name="' + side + '-size"]').forEach(function (input) {
      var available = setSizeAvailable(side, input.value);
      /* A class, not the disabled attribute -- the simple page keeps these
         clickable so the shopper can land on a sold-out size and be told. */
      input.classList.toggle('disabled', !available);
      if (input.checked && !available) soldOut = true;
    });
  });

  var button = document.getElementById('add-to-cart-button');
  if (button) {
    button.disabled = soldOut;
    var label = soldOut
      ? button.getAttribute('data-label-sold-out') || 'Sold out'
      : button.getAttribute('data-label-default') || 'Add Set to Cart';
    if (button.textContent.trim() !== label) button.textContent = label;

    var selector = button.getAttribute('data-price-selector');
    var price = selector ? document.querySelector(selector) : null;
    if (!price) price = document.querySelector('.product__info-container .price');
    if (price) price.classList.toggle('price--sold-out', soldOut);
  }
}

// Event listener for the button click
document.getElementById('add-to-cart-button').addEventListener('click', function() {
  var { topVariantId, bottomVariantId } = getSelectedValues();
  if (topVariantId && bottomVariantId) {
    addToCart(topVariantId, bottomVariantId);
  } else {
    console.log('Top or bottom variant ID not found.');
  }
});

// Event listener for variant selection changes
document.querySelectorAll('input[name="color"], input[name="top-size"], input[name="top-material"], input[name="bottom-size"], input[name="bottom-material"]').forEach(function(input) {
  input.addEventListener('change', function() {
    updateButtonState();
  });
});


document.addEventListener('DOMContentLoaded', updateButtonState);
if (document.readyState !== 'loading') updateButtonState();

document.addEventListener("DOMContentLoaded", function () {
  const colorRadios = document.querySelectorAll('.color-radio');
  const selectedColorName = document.querySelector('.selected-color-name');

  function updateSelectedColor() {
    const checkedRadio = document.querySelector('.color-radio:checked');
    if (checkedRadio && selectedColorName) {
      selectedColorName.textContent = checkedRadio.value;
    }
  }

  // Initial load update
  updateSelectedColor();

  // On change update
  colorRadios.forEach(radio => {
    radio.addEventListener('change', updateSelectedColor);
  });
});